import { lazy, Suspense } from 'react'

const DraftJSEditorComponent = lazy(() => import('.'))

export const DraftJSEditor: React.VFC = (props) => (
  <Suspense fallback={null}>
    <DraftJSEditorComponent {...props} />
  </Suspense>
)
